import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 4,
			r: 2,
			fill: "#0E204D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 8,
			width: 4,
			height: 10,
			rx: 2,
			fill: "#0E204D"
		})
	]
});
export default SvgInfo;
